<template>
  <div>
    <base-sub-title title="User Information" />
    <v-form ref="User" v-model="form_valid" lazy-validation>
      <v-row class="mx-1">
        <base-column :lg="4" :md="4" :sm="12">
          <v-text-field label="Name" outlined dense v-model="User.name" :rules="rule_name"></v-text-field>
        </base-column>
        <base-column :lg="4" :md="4" :sm="12">
          <v-text-field label="Phone" outlined dense v-model="User.phone"></v-text-field>
        </base-column>
        <base-column :lg="4" :md="4" :sm="12">
          <v-text-field type="email" label="Email" outlined dense v-model="User.email"></v-text-field>
        </base-column>
      </v-row>
      <v-row class="mx-1">
        <base-column :lg="4" :md="4" :sm="12">
          <v-textarea rows="1" label="Address" v-model="User.address" outlined dense></v-textarea>
        </base-column>
        <base-column :lg="4" :md="4" :sm="12">
          <v-select label="Role" outlined dense v-model="User.role_id" :items="role" :rules="rule_role" item-text="name"
            item-value="id"></v-select>
        </base-column>
        <base-column :lg="4" :md="4" :sm="12">
          <v-text-field label="Username" outlined dense v-model="User.username" :rules="rule_username"></v-text-field>
        </base-column>
      </v-row>
      <v-row class="mx-1">
        <base-column :lg="4" :md="4" :sm="12">
          <v-text-field v-model="User.password" label="Password" outlined dense
            :append-icon="show_current ? 'mdi-eye' : 'mdi-eye-off'" :type="show_current ? 'text' : 'password'"
            @click:append="show_current = !show_current" :rules="rule_password">
          </v-text-field>
        </base-column>
        <base-column :lg="4" :md="4" :sm="12">
          <v-text-field label="Retype Password" v-model="User.password_confirmation" outlined dense
            :append-icon="show_new ? 'mdi-eye' : 'mdi-eye-off'" :type="show_new ? 'text' : 'password'"
            @click:append="show_new = !show_new" :rules="rule_retype_password">
          </v-text-field>
        </base-column>
        <base-column :lg="4" :md="4" :sm="12">
          <v-switch v-model="User.is_active" class="mt-1" label="USE">
          </v-switch>
        </base-column>
      </v-row>
      <v-row class="mx-1">
        <base-column :lg="4" :md="4" :sm="12" v-if="(ROLE == 'Owner')">
          <v-select label="Branch" :items="branch" v-model="User.branch_id" dense item-text="name" item-value="id"
            outlined></v-select>
        </base-column>
      </v-row>
      <v-row class="mx-1">
        <v-btn small class="ma-2" color="darkblue" outlined @click="back()" title="Back">
          <v-icon left>mdi-arrow-left </v-icon>
          Back</v-btn>
        <v-btn small color="secondary" class="ma-2" @click="clearForm()">
          Clear
          <v-icon>mdi-close-circle-multiple </v-icon>
        </v-btn>
        <v-btn color="primary" small class="ma-2" @click.stop="store" :loading="btnLoading"
          :disabled="!form_valid || btnLoading">Save
          <v-icon right>mdi-content-save</v-icon></v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import BaseColumn from "@/components/base/BaseColumn";
import BaseSubTitle from "@/components/base/BaseSubTitle";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  name: "ProductForm",
  data() {
    return {
      btnLoading: false,
      form_valid: true,
      branch: [],
      show_current: false,
      show_new: false,
      new_password: "",
      current_password: "",
      role: [],
    };
  },
  created() {
    this.getRole();
    this.getBranch();
  },

  methods: {
    ...mapMutations("user", ["CLEAR_STATE", "SET_USER"]),

    store: async function () {
      if (this.$refs.User.validate()) {
        this.btnLoading = true;
        await this.$axios
          .post("/master/user", this.User,
            {
              headers: { Authorization: this.$store.getters["auth/Token"] },
            })
          .then(() => {
            this.CLEAR_STATE();
            this.btnLoading = false;
            this.$router.push({ name: "users.index" });
          })
          .catch(() => {
            this.btnLoading = false;
          });
      }
    },

    async getBranch() {
      await this.$axios("/master/branches?active=1", {
        headers: {
          Authorization: this.$store.getters["auth/Token"],
        },
      }).then(({ data }) => {
        this.branch = data.branch.data;
      });
    },

    async getRole() {
      await this.$axios("/system/roles", {
        headers: {
          Authorization: this.$store.getters["auth/Token"],
        },
      }).then(({ data }) => {
        this.role = data.roles.data;
      });
    },

    clearForm() {
      this.CLEAR_STATE();
    },

    back() {
      this.CLEAR_STATE();
      this.$router.push({ name: "users.index" });
    },
  },

  computed: {
    ...mapState("user", {
      User: (state) => state.user,
    }),

    ...mapGetters("auth", {
      ROLE: "Role",
    }),

    User() {
      return this.$store.getters["user/User"];
    },
  },

  components: {
    BaseColumn,
    BaseSubTitle,
  },
};
</script>